// MainLayout.tsx
import { FC, ReactNode } from 'react';

import BackgroundImage from './BackgroundImage.tsx';
import { HelpDrawer } from './HelpDrawer.tsx';

type Props = {
  children?: ReactNode;
};

export const MainLayout: FC<Props> = ({ children }) => {
  return (
    <div className="flex h-screen min-h-0 overflow-hidden">
      <div className="flex min-h-0 flex-1">
        <div
          id="left-col"
          className="flex min-h-0 flex-col flex-1 overflow-hidden md:w-1/2 md:max-w-[800px]"
          style={{
            background:
              'linear-gradient(0deg, var(--gradient-gradient-stop-0, #fff) 0%, var(--gradient-gradient-stop-100, #fff) 100%)',
          }}
        >
          {children}
        </div>

        <div id="right-col" className="hidden md:block flex-1 md:w-1/2">
          <BackgroundImage />
        </div>
      </div>
      <HelpDrawer />
    </div>
  );
};
